import React, { Fragment } from "react";
import { Box } from "@material-ui/core";
import { Favorite, ThumbUpAlt } from "@material-ui/icons";
import { useStyles } from "./styles";

const DisplayReaction = ({ loveCount, likeCount }) => {
  const classes = useStyles();

  return (
    <Box className={classes.displayReaction} display="flex">
      {likeCount ? (
        <Fragment>
          <ThumbUpAlt fontSize="small" className={classes.likeIcon} />
          {likeCount}
        </Fragment>
      ) : null}
      {loveCount ? (
        <Fragment>
          <Favorite fontSize="small" className={classes.loveIcon} />
          {loveCount}
        </Fragment>
      ) : null}
    </Box>
  );
};

export default DisplayReaction;
